import InputTimePicker from './InputTimePicker.component';

export default InputTimePicker;
